module.exports = __webpack_public_path__ + "static/img/road1.0fc17ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road1.png
// module id = bvnn
// module chunks = 1